/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        globalHeader: {
            gap: {
                value: "12px",
                type: "dimension",
            },
            height: {
                value: "64px",
                type: "dimension",
            },
            paddingLeft: {
                value: "12px",
                type: "dimension",
            },
            paddingRight: {
                value: "12px",
                type: "dimension",
            },
            borderBottomColor: {
                value: "#e6e6e6",
                type: "color",
            },
            borderBottomWidth: {
                value: "1px",
                type: "dimension",
            },
            borderBottomStyle: {
                value: "solid",
                type: "stokeStyle",
            },
            leadingSlot: {
                padding: {
                    value: "4px",
                    type: "dimension",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
            },
            trailingSlot: {
                gap: {
                    value: "8px",
                    type: "dimension",
                },
            },
            public: {
                leadingSlot: {
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
